<div class="empathy-notepad-full-preview">
  @if (selectedActiveDevice()) {
    <div class="empathy-notepad-full-preview__link">
      <div class="empathy-notepad-full-preview__link__label"><fa-icon [icon]="faEye"></fa-icon><span class="fs__lg fw__600">Preview</span></div>
      <button mat-button color="primary" (click)="fullPreview.emit()">
        <div>
          <span class="fs__sm fw__600">Open full preview</span>
          <fa-icon [icon]="faArrowUpRightFromSquare"></fa-icon>
        </div>
      </button>
    </div>
  }
  @if (!selectedActiveDevice()) {
    <mat-toolbar class="empathy-notepad-full-preview__toolbar">
      <div class="empathy-notepad-full-preview__toolbar__devices">
        <button
          mat-stroked-button
          [class.active]="activeDevice$() === previewDevice.Desktop"
          (click)="activeDevice$.set(previewDevice.Desktop)"
          class="fs__md fw__600"
        >
          <fa-icon [icon]="faDesktop"></fa-icon>
          Desktop
        </button>
        <button
          mat-stroked-button
          [class.active]="activeDevice$() === previewDevice.Phone"
          (click)="activeDevice$.set(previewDevice.Phone)"
          class="fs__md fw__600"
        >
          <fa-icon [icon]="faMobile"></fa-icon>
          Phone
        </button>
        <button
          mat-stroked-button
          [class.active]="activeDevice$() === previewDevice.Tablet"
          (click)="activeDevice$.set(previewDevice.Tablet)"
          class="fs__md fw__600"
        >
          <fa-icon [icon]="faTablet"></fa-icon>
          Tablet
        </button>
      </div>
    </mat-toolbar>
  }
  <empathy-device-wrapper [ngClass]="selectedActiveDevice() ?? activeDevice$()" [activeDevice]="selectedActiveDevice() ?? activeDevice$()">
    @if (this.surveyModel$()) {
      <empathy-dep-viewer
        [progressSaved]="isProgressSaved$()"
        [surveyModel]="this.surveyModel$()"
        (completedSurvey)="onPreviewCompletedSurvey($event)"
        (progress)="onPreviewProgress($event)"
        (started)="onPreviewStarted()"
        (completed)="onPreviewCompleted()"
      ></empathy-dep-viewer>
    }
  </empathy-device-wrapper>
</div>
